// Campos do laudo de calibracao de CALIBRADOR DE PNEUS.
// Para mudar esse formulario, mexa so neste arquivo.
const calibradorPneu = {
  titulo: 'Calibrador de Pneus',
  leituras: 'carga',
  secoes: [
    {
      titulo: 'Identificação do instrumento',
      campos: [
        { n: 'tag', l: 'TAG', t: 'texto', span: 4, up: true, ajuda: 'Identificação do calibrador dentro do cliente. Ex.: CA-01.' },
        { n: 'marca', l: 'Marca', t: 'texto', span: 5, ajuda: 'Fabricante gravado no instrumento. Em branco sai NÃO CONSTA no laudo.' },
        { n: 'modelo', l: 'Modelo', t: 'texto', span: 5, ajuda: 'Modelo do fabricante, quando houver.' },
        { n: 'numero_serie', l: 'Nº de série', t: 'texto', span: 5, ajuda: 'Número de série do instrumento, quando houver.' },
        { n: 'tipo_instrumento', l: 'Tipo', t: 'sel', span: 5, ajuda: 'Como o calibrador indica a pressão.',
          o: [['digital', 'Digital'], ['analogico', 'Analógico']] },
        { n: 'classe', l: 'Classe', t: 'texto', span: 4, ajuda: 'Classe de exatidão informada pelo fabricante. Sem essa informação na placa, deixe vazio.' },
        { n: 'conexao', l: 'Conexão', t: 'sel', span: 4, ajuda: 'Bitola do engate do calibrador.',
          o: [['1/4', '1/4"'], ['1/2', '1/2"'], ['3/4', '3/4"'], ['outra', 'Outra']] },
        { n: 'local_instalacao', l: 'Local de instalação', t: 'texto', span: 6, up: true, ajuda: 'Onde o calibrador fica. Se for equipamento móvel, pode repetir a TAG.' },
        { n: 'unidade', l: 'Unidade', t: 'sel', span: 4, fixo: true, o: [['PSI', 'PSI']],
          ajuda: 'Calibrador de pneu é sempre registrado em PSI, que é o que a grande maioria dos aparelhos mostra.' },
        { n: 'validade_anos', l: 'Validade', t: 'sel', span: 3, ajuda: 'De quanto em quanto tempo o calibrador deve ser recalibrado.',
          o: [[1, '1 ano'], [2, '2 anos'], [3, '3 anos'], [4, '4 anos'], [5, '5 anos']] },
        { n: 'data_calibracao', l: 'Data', t: 'data', span: 3, ajuda: 'Data em que a calibração foi executada.' }
      ]
    },
    {
      titulo: 'Faixa e condições',
      campos: [
        { n: 'temp_min', l: 'Mínima da escala', t: 'num', span: 4, ajuda: 'Menor valor que o calibrador mede. Normalmente 0.' },
        { n: 'temp_max', l: 'Máxima da escala', t: 'num', span: 4, ajuda: 'Maior valor que o calibrador mede, o fim da escala.' },
        { n: '_amplitude', l: 'Amplitude', t: 'calc', span: 4, ajuda: 'Máxima menos mínima. Calculada sozinha, não é digitada.',
          calc: (v) => (v.temp_min != null && v.temp_max != null) ? String(Number(v.temp_max) - Number(v.temp_min)).replace('.', ',') : '' },
        { n: 'resolucao', l: 'Resolução', t: 'num', span: 4, ajuda: 'Menor divisão que o calibrador mostra. Ex.: 1 para um display que anda de 1 em 1 PSI.' },
        { n: 'temp_ambiente', l: 'Temperatura ambiente', t: 'texto', span: 4, ajuda: 'Temperatura do ambiente durante a calibração, com a tolerância. Vai assim mesmo para o laudo.' },
        { n: 'umidade', l: 'Umidade do ar', t: 'texto', span: 4, ajuda: 'Umidade do ambiente durante a calibração, com a tolerância.' }
      ]
    }
  ],
  pontos: {
    ajuda: 'V.M é a pressão indicada pelo manômetro padrão no ponto. VVC é o que o calibrador mostrou, subindo (carregamento) e descendo (descarregamento).',
    colunas: [
      { n: 'vm', l: 'V.M — valor do padrão', ajuda: 'Pressão de referência do ponto, lida no padrão.' },
      { n: 'carga', l: 'VVC carregamento', ajuda: 'Leitura do calibrador com a pressão subindo.' },
      { n: 'desc', l: 'VVC descarregamento', ajuda: 'Leitura do calibrador com a pressão descendo.' }
    ]
  },
  fechamento: [
    { n: 'fator_k', l: 'Fator k', t: 'sel', span: 4, o: [[2, '2 (95%)'], [3, '3 (99%)']],
      ajuda: 'Multiplicador da incerteza padrão para chegar na incerteza expandida. k = 2 corresponde a cerca de 95% de confiança.' },
    { n: 'danificado', l: 'Danificado?', t: 'bool', span: 4, ajuda: 'Marque se o calibrador chegou com dano que impeça o uso.' },
    { n: 'substituido', l: 'Substituído?', t: 'bool', span: 4, ajuda: 'Marque se o calibrador foi trocado por outro no atendimento.' }
  ]
};

export default calibradorPneu;
